import { render, staticRenderFns } from "./ModalUserEventMessenger.vue?vue&type=template&id=70234946&"
import script from "./ModalUserEventMessenger.vue?vue&type=script&lang=ts&"
export * from "./ModalUserEventMessenger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports